import React, { useState, useEffect, useContext } from "react";
import AdminContext from "../../../StateContext/Application";
import {
  Email32,
  Location32,
  PhoneNumber32,
} from "../../../../../public/LoginImages/importimages";
import { apiurl } from "../../../../../path";
import { useLanguage } from "../../../../../lang/langcontext/LanguageContext";
import GooglePagination from "../../../styles/GooglePagination";
const VendorList = () => {
  const { language, toggleLanguage, t } = useLanguage();
  const context = useContext(AdminContext);
  const { GetVendors } = context;
  const [vendor, setVendor] = useState([]);
  const [filteredBills, setFilteredBills] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const billsPerPage = 10;
  const [searchTerm, setSearchTerm] = useState("");
  const [deletedVentor, setDeletedVentor] = useState(null);

  const totalPages = Math.ceil(filteredBills.length / billsPerPage);
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
  const sortedBills = Array.isArray(filteredBills)
    ? filteredBills
        .slice() // ✅ prevent state mutation
        .sort((a, b) => new Date(b.Date) - new Date(a.Date))
    : [];
  const currentBills = sortedBills?.slice(indexOfFirstBill, indexOfLastBill);
  const getVendors = async () => {
    let data = await GetVendors();
    setVendor(data);
    setFilteredBills(data);
  };
  useEffect(() => {
    getVendors();
  }, []);
  let vendorList = [];
  if (vendor.length > 0) {
    vendorList = vendor;
  }
  useEffect(() => {
    const lowerSearchTerm = searchTerm.toLowerCase();
    const filtered = vendor.filter((bill) =>
      Object.values(bill).some((val) =>
        (val || "").toString().toLowerCase().includes(lowerSearchTerm),
      ),
    );
    setFilteredBills(filtered);
    setCurrentPage(1); // Reset to page 1 on search
  }, [searchTerm, vendor]);

  const headerStyle = {
    padding: "12px 16px",
    whiteSpace: "nowrap",
    borderRight: "1px solid #e0e0e0",
    textTransform: "capitalize",
  };

  const handleDeleteDeduction = async (UniqueID, e) => {
    e.preventDefault();

    if (!window.confirm("Are you sure you want to delete this vendor?")) {
      return;
    }

    setDeletedVentor(UniqueID);

    try {
      const response = await GetVendors(UniqueID);

      if (response.success) {
        alert("Vendor deleted successfully");
        getVendors();
      } else {
        alert(response.message || "Failed to delete vendor");
      }
    } catch (error) {
      console.error("Error deleting vendor:", error);
      alert("Failed to delete vendor. Please try again.");
    } finally {
      setDeletedVentor(null);
    }
  };

  // return (

  //     <>
  //         <div sclassName="col-12" style={{ backgroundColor: "#EFF3F8", height: "89vh", overflowX: "hidden", overflowY: "scroll" }}>

  //             <div className="col-11 m-auto">
  //                 <div className="col-12">

  //                     <div className='col-12 px-4 mb-4 mt-3' style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
  //                         {/* <h4 style={{ margin: "10px 0px" }}></h4> */}
  //                         <h5 className='my-auto fw-bold'>
  //                             <img src="/GR-Approval64.png" alt="Vendor Report" style={{ width: "24px", height: "24px" }} className='my-auto me-1' />
  //                             <span className='my-auto'>Vendor List</span>
  //                         </h5>
  //                         {/* <input type="text" placeholder="Search" onChange={(e) => setSearchTerm(e.target.value)}
  //                         value={searchTerm}
  //                         style={{ width: "250px", padding: "8px 12px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: 'aliceblue', fontSize: "14px", marginRight: "10px" }} /> */}

  //                         <div style={{ position: "relative", width: "250px", marginRight: "10px" }}>
  //                             <img
  //                                 src="/Search32.png"
  //                                 alt="Search Icon"
  //                                 style={{
  //                                     position: "absolute",
  //                                     top: "50%",
  //                                     left: "10px",
  //                                     transform: "translateY(-50%)",
  //                                     width: "16px",
  //                                     height: "16px",
  //                                     opacity: 0.6
  //                                 }}
  //                             />
  //                             <input
  //                                 type="text"
  //                                 placeholder="Search Here"
  //                                 onChange={(e) => setSearchTerm(e.target.value)}
  //                                 value={searchTerm}
  //                                 style={{
  //                                     width: "100%",
  //                                     padding: "8px 12px 8px 32px", // left padding makes space for icon
  //                                     border: "1px solid #ccc",
  //                                     borderRadius: "8px",
  //                                     backgroundColor: "#f1f6fc",
  //                                     fontSize: "14px",
  //                                     color: "#333",
  //                                     boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
  //                                     outline: "none"
  //                                 }}
  //                             />
  //                         </div>
  //                     </div>

  //                     <div className="col-12 pb-5">
  //                         <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%", maxWidth: "100%", overflowX: "hidden" }}>
  //                             <div className='col-12 tableDesign' style={{ background: '#2C78DB', overflowX: 'scroll' }}>
  //                                 <table className='m-0 p-0' style={{ width: '100%', borderCollapse: 'collapse' }}>
  //                                     <thead>
  //                                         <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>
  //                                             <th style={{ minWidth: "40px", padding: "8px" }}>Sr.no.</th>
  //                                             <th style={{ minWidth: "100px", padding: '8px' }}>Unique ID</th>
  //                                             <th style={{ minWidth: "120px", padding: '8px' }}>Company Name</th>
  //                                             <th style={{ minWidth: "120px", padding: '8px' }}>Email</th>
  //                                             <th style={{ minWidth: "200px", padding: '8px' }}>Address</th>
  //                                             <th style={{ minWidth: "100px", padding: '8px' }}> City</th>
  //                                             <th style={{ minWidth: "100px", padding: '8px' }}> Pincode</th>
  //                                             <th style={{ minWidth: "120px", padding: '8px' }}> Phone Number</th>
  //                                             <th style={{ minWidth: "100px", padding: '8px' }}> GST NUMBER</th>
  //                                             <th style={{ minWidth: "100px", padding: '8px' }}> PAN NUMBER</th>
  //                                             <th style={{ minWidth: "100px", padding: '8px' }}> Account Number</th>
  //                                             <th style={{ minWidth: "100px", padding: '8px' }}> Bank Name</th>
  //                                             <th style={{ minWidth: "100px", padding: '8px' }}> IFSC CODE</th>
  //                                             <th style={{ minWidth: "150px", padding: '8px' }}> Branch Name</th>
  //                                             {/* <th style={{ minWidth: "200px", padding: '8px' }}> Account Holder Name</th> */}
  //                                             <th style={{ minWidth: "200px", padding: '8px' }}>Paasbook Doc</th>
  //                                             <th style={{ minWidth: "200px", padding: '8px' }}>Cheque Doc</th>
  //                                             <th style={{ minWidth: "200px", padding: '8px' }}>Pan Doc</th>
  //                                             <th style={{ minWidth: "200px", padding: '8px' }}>Tan Doc</th>
  //                                             <th style={{ minWidth: "200px", padding: '8px' }}>GST Doc</th>
  //                                             <th style={{ minWidth: "200px", padding: '8px' }}>Aadhaar Doc</th>
  //                                         </tr>
  //                                     </thead>
  //                                     {currentBills?.length === 0 ? (
  //                                         <tr>
  //                                             <td colSpan="20" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>
  //                                                 No data available
  //                                             </td>
  //                                         </tr>
  //                                     ) : (
  //                                         currentBills.map((vendor, index) => {
  //                                             const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
  //                                             return (
  //                                                 <tbody>
  //                                                     <tr key={index} style={{ backgroundColor: bgColor, fontSize: "12px", fontWeight: "500" }}>
  //                                                         <td style={{ padding: '8px' }}>{(currentPage - 1) * billsPerPage + index + 1}</td>
  //                                                         <td style={{ padding: '8px' }}>{vendor.UniqueID}</td>
  //                                                         <td style={{ padding: '8px' }}>{vendor.Bidder_CompanyName}</td>
  //                                                         <td>
  //                                                             <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
  //                                                                 <img src={Email32} alt="email" style={{ width: '16px', height: '16px' }} />
  //                                                                 <span>{vendor.Email}</span>
  //                                                             </div>
  //                                                         </td>
  //                                                         <td style={{ padding: '8px' }}>
  //                                                             <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
  //                                                                 <img src={Location32} alt="address" style={{ width: '16px', height: '16px' }} />
  //                                                                 <span>{vendor.Address}</span>
  //                                                             </div>
  //                                                         </td>
  //                                                         <td style={{ padding: '8px' }}>{vendor.City}</td>
  //                                                         <td style={{ padding: '8px' }}>{vendor.PinCode}</td>
  //                                                         <td >
  //                                                             <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
  //                                                                 <img src={PhoneNumber32} alt='Phone Number' style={{ width: '16px', height: '16px' }} />
  //                                                                 <span>{vendor.Mobile_No}</span>
  //                                                             </div>
  //                                                         </td>
  //                                                         <td style={{ padding: '8px' }}>{vendor.GST_No}</td>
  //                                                         <td style={{ padding: '8px' }}>{vendor.PAN_No}</td>
  //                                                         <td style={{ padding: '8px' }}>{vendor.Account_Number}</td>
  //                                                         <td style={{ padding: '8px' }}>{vendor.BANK_NAME}</td>
  //                                                         <td style={{ padding: '8px' }}>{vendor.IFSC_CODE}</td>
  //                                                         <td style={{ padding: '8px' }}>{vendor.BranchName}</td>
  //                                                         {/* <td style={{ padding: '8px' }}>{vendor.Account_HolderName}</td> */}
  //                                                         <td style={{ padding: '8px' }}><a href={`${apiurl}/ContractorDocsImages/${vendor.PaasbookDoc}`} target='_blank'>{vendor.PaasbookDoc}</a></td>
  //                                                         <td style={{ padding: '8px' }}><a href={`${apiurl}/ContractorDocsImages/${vendor.ChequeDoc}`} target='_blank'>{vendor.ChequeDoc}</a></td>
  //                                                         <td style={{ padding: '8px' }}><a href={`${apiurl}/ContractorDocsImages/${vendor.PanDoc}`} target='_blank'>{vendor.PanDoc}</a></td>
  //                                                         <td style={{ padding: '8px' }}><a href={`${apiurl}/ContractorDocsImages/${vendor.TanDoc}`} target='_blank'>{vendor.TanDoc}</a></td>
  //                                                         <td style={{ padding: '8px' }}><a href={`${apiurl}/ContractorDocsImages/${vendor.GstDoc}`} target='_blank'>{vendor.GstDoc}</a></td>
  //                                                         <td style={{ padding: '8px' }}><a href={`${apiurl}/ContractorDocsImages/${vendor.AadharDoc}`} target='_blank'>{vendor.AadharDoc}</a></td>
  //                                                     </tr>
  //                                                 </tbody>
  //                                             );
  //                                         })
  //                                     )}
  //                                 </table>
  //                             </div>

  //                             <div className='col-12 mt-4'>
  //                                 <div className="row">

  //                                     <div className='col-6'>
  //                                         <p className="text-gray-600" style={{ fontSize: "14px" }}>
  //                                             Showing {indexOfFirstBill + 1} to {Math.min(indexOfLastBill, filteredBills.length)} of {filteredBills.length} entries
  //                                         </p>
  //                                     </div>

  //                                     <div className='col-6' style={{ display: 'flex', alignItems: 'center', justifyContent: "end" }}>
  //                                         {/* First Page Button */}
  //                                         <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
  //                                             style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', width: '2rem' }}>
  //                                             &laquo;
  //                                         </button>
  //                                         {/* Previous Button */}
  //                                         <button
  //                                             onClick={() => setCurrentPage(currentPage - 1)}
  //                                             disabled={currentPage === 1}
  //                                             style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
  //                                             &lt;
  //                                         </button>

  //                                         <button
  //                                             style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '20px', width: '2.4rem', border: '1px solid lightgrey', borderLeft: "none" }}>{currentPage}
  //                                         </button>
  //                                         {/* Next Button */}
  //                                         <button
  //                                             onClick={() => setCurrentPage(currentPage + 1)}
  //                                             disabled={currentPage === totalPages}
  //                                             style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
  //                                             &gt;
  //                                         </button>
  //                                         {/* Last Page Button */}
  //                                         <button
  //                                             onClick={() => setCurrentPage(totalPages)}
  //                                             disabled={currentPage === totalPages}
  //                                             style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
  //                                             &raquo;
  //                                         </button>
  //                                     </div>

  //                                 </div>
  //                             </div>

  //                         </div>
  //                     </div>

  //                 </div>
  //             </div>

  //         </div>
  //     </>
  // )

  return (
    <>
      <div
        sclassName="col-12"
        style={{
          backgroundColor: "#EFF3F8",
          height: "89vh",
          overflowX: "hidden",
          overflowY: "scroll",
        }}
      >
        <div className="col-11 m-auto">
          <div className="col-12">
            <div
              className="col-12 px-4 mb-4 mt-3"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              {/* <h4 style={{ margin: "10px 0px" }}></h4> */}
              <h5 className="my-auto fw-bold">
                <img
                  src="/GR-Approval64.png"
                  alt="Vendor Report"
                  style={{ width: "24px", height: "24px" }}
                  className="my-auto me-1"
                />
                <span className="my-auto">{t("Vendor List")}</span>
              </h5>
              {/* <input type="text" placeholder="Search" onChange={(e) => setSearchTerm(e.target.value)}
                            value={searchTerm}
                            style={{ width: "250px", padding: "8px 12px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: 'aliceblue', fontSize: "14px", marginRight: "10px" }} /> */}

              <div
                style={{
                  position: "relative",
                  width: "250px",
                  marginRight: "10px",
                }}
              >
                <img
                  src="/Search32.png"
                  alt="Search Icon"
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "10px",
                    transform: "translateY(-50%)",
                    width: "16px",
                    height: "16px",
                    opacity: 0.6,
                  }}
                />
                <input
                  type="text"
                  placeholder={t("Search Here")}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  value={searchTerm}
                  style={{
                    width: "100%",
                    padding: "8px 12px 8px 32px", // left padding makes space for icon
                    border: "1px solid #ccc",
                    borderRadius: "8px",
                    backgroundColor: "#f1f6fc",
                    fontSize: "18px",
                    color: "#333",
                    boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                    outline: "none",
                  }}
                />
              </div>
            </div>

            <div className="col-12 pb-5">
              <div
                className="m-auto mb-3"
                style={{
                  backgroundColor: "white",
                  padding: "40px 40px",
                  boxShadow: "0px 0px 5px 1px #E4E8EC",
                  borderRadius: "20px",
                  width: "100%",
                  maxWidth: "100%",
                  overflowX: "hidden",
                }}
              >
                <div
                  className="col-12 tableDesign"
                  style={{ background: "#2C78DB", overflowX: "auto",
                      overflowY: "auto",
                      maxHeight: "600px", // change height as needed
                      position: "relative", }}
                >
                  {/* <table className='m-0 p-0' style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <thead>
                                            <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>
                                                <th style={{ minWidth: "40px", padding: "8px" }}>{t("Sr.no.")}</th>
                                                <th style={{ minWidth: "100px", padding: '8px' }}>{t("Unique ID")}</th>
                                                <th style={{ minWidth: "120px", padding: '8px' }}>{t("Company Name")}</th>
                                                <th style={{ minWidth: "120px", padding: '8px' }}>{t("Email")}</th>
                                                <th style={{ minWidth: "200px", padding: '8px' }}>{t("Address")}</th>
                                                <th style={{ minWidth: "100px", padding: '8px' }}>{t("City")}</th>
                                                <th style={{ minWidth: "100px", padding: '8px' }}>{t("Pincode")}</th>
                                                <th style={{ minWidth: "120px", padding: '8px' }}>{t("Phone Number")}</th>
                                                <th style={{ minWidth: "100px", padding: '8px' }}>{t("GST NUMBER")}</th>
                                                <th style={{ minWidth: "100px", padding: '8px' }}>{t("PAN NUMBER")}</th>
                                                <th style={{ minWidth: "100px", padding: '8px' }}>{t("Account Number")}</th>
                                                <th style={{ minWidth: "100px", padding: '8px' }}>{t("Bank Name")}</th>
                                                <th style={{ minWidth: "100px", padding: '8px' }}>{t("IFSC CODE")}</th>
                                                <th style={{ minWidth: "150px", padding: '8px' }}>{t("Branch Name")}</th>
                                               
                                                <th style={{ minWidth: "200px", padding: '8px' }}>{t("Passbook Doc")}</th>
                                                <th style={{ minWidth: "200px", padding: '8px' }}>{t("Cheque Doc")}</th>
                                                <th style={{ minWidth: "200px", padding: '8px' }}>{t("Pan Doc")}</th>
                                                <th style={{ minWidth: "200px", padding: '8px' }}>{t("Tan Doc")}</th>
                                                <th style={{ minWidth: "200px", padding: '8px' }}>{t("GST Doc")}</th>
                                                <th style={{ minWidth: "200px", padding: '8px' }}>{t("Aadhaar Doc")}</th>
                                            </tr>
                                        </thead>
                                        {currentBills?.length === 0 ? (
                                            <tr>
                                                <td colSpan="20" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>
                                                    {t("No data available")}
                                                </td>
                                            </tr>
                                        ) : (
                                            currentBills.map((vendor, index) => {
                                                const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                                return (
                                                    <tbody>
                                                        <tr key={index} style={{ backgroundColor: bgColor, fontSize: "12px", fontWeight: "500" }}>
                                                            <td style={{ padding: '8px' }}>{(currentPage - 1) * billsPerPage + index + 1}</td>
                                                            <td style={{ padding: '8px' }}>{vendor.UniqueID}</td>
                                                            <td style={{ padding: '8px' }}>{vendor.Bidder_CompanyName}</td>
                                                            <td>
                                                                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                    <img src={Email32} alt="email" style={{ width: '16px', height: '16px' }} />
                                                                    <span>{vendor.Email}</span>
                                                                </div>
                                                            </td>
                                                            <td style={{ padding: '8px' }}>
                                                                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                    <img src={Location32} alt="address" style={{ width: '16px', height: '16px' }} />
                                                                    <span>{vendor.Address}</span>
                                                                </div>
                                                            </td>
                                                            <td style={{ padding: '8px' }}>{vendor.City}</td>
                                                            <td style={{ padding: '8px' }}>{vendor.PinCode}</td>
                                                            <td >
                                                                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                    <img src={PhoneNumber32} alt='Phone Number' style={{ width: '16px', height: '16px' }} />
                                                                    <span>{vendor.Mobile_No}</span>
                                                                </div>
                                                            </td>
                                                            <td style={{ padding: '8px' }}>{vendor.GST_No}</td>
                                                            <td style={{ padding: '8px' }}>{vendor.PAN_No}</td>
                                                            <td style={{ padding: '8px' }}>{vendor.Account_Number}</td>
                                                            <td style={{ padding: '8px' }}>{vendor.BANK_NAME}</td>
                                                            <td style={{ padding: '8px' }}>{vendor.IFSC_CODE}</td>
                                                            <td style={{ padding: '8px' }}>{vendor.BranchName}</td>

                                                            <td style={{ padding: '8px' }}><a href={`${apiurl}/ContractorDocsImages/${vendor.PaasbookDoc}`} target='_blank'>{vendor.PaasbookDoc}</a></td>
                                                            <td style={{ padding: '8px' }}><a href={`${apiurl}/ContractorDocsImages/${vendor.ChequeDoc}`} target='_blank'>{vendor.ChequeDoc}</a></td>
                                                            <td style={{ padding: '8px' }}><a href={`${apiurl}/ContractorDocsImages/${vendor.PanDoc}`} target='_blank'>{vendor.PanDoc}</a></td>
                                                            <td style={{ padding: '8px' }}><a href={`${apiurl}/ContractorDocsImages/${vendor.TanDoc}`} target='_blank'>{vendor.TanDoc}</a></td>
                                                            <td style={{ padding: '8px' }}><a href={`${apiurl}/ContractorDocsImages/${vendor.GstDoc}`} target='_blank'>{vendor.GstDoc}</a></td>
                                                            <td style={{ padding: '8px' }}><a href={`${apiurl}/ContractorDocsImages/${vendor.AadharDoc}`} target='_blank'>{vendor.AadharDoc}</a></td>
                                                        </tr>
                                                    </tbody>
                                                );
                                            })
                                        )}
                                    </table> */}

                  <table
                    className="m-0 p-0"
                    style={{ width: "100%", borderCollapse: "collapse" }}
                  >
                    <thead style={{ position: "sticky",  backgroundColor: "#1976d2",
                      top: 0,
                      zIndex: 10,}}>
                      <tr
                        style={{
                          color: "white",
                          border: "none",
                          height: "3rem",
                          fontSize: "18px",
                        }}
                      >
                        <th
                          style={{ minWidth: "40px", padding: "8px" }}
                          rowSpan={2}
                        >
                          {t("Sr.no.")}
                        </th>
                        <th
                          style={{ minWidth: "100px", padding: "8px" }}
                          rowSpan={2}
                        >
                          {t("Unique ID")}
                        </th>
                        <th
                          style={{ minWidth: "120px", padding: "8px" }}
                          rowSpan={2}
                        >
                          {t("Company Name")}
                        </th>
                        <th
                          style={{ minWidth: "120px", padding: "8px" }}
                          rowSpan={2}
                        >
                          {t("Email")}
                        </th>
                        <th
                          style={{ minWidth: "200px", padding: "8px" }}
                          rowSpan={2}
                        >
                          {t("Address")}
                        </th>
                        <th
                          style={{ minWidth: "100px", padding: "8px" }}
                          rowSpan={2}
                        >
                          {t("City")}
                        </th>
                        <th
                          style={{ minWidth: "100px", padding: "8px" }}
                          rowSpan={2}
                        >
                          {t("Pincode")}
                        </th>
                        <th
                          style={{ minWidth: "120px", padding: "8px" }}
                          rowSpan={2}
                        >
                          {t("Phone Number")}
                        </th>
                        <th
                          style={{ minWidth: "100px", padding: "8px" }}
                          rowSpan={2}
                        >
                          {t("GST NUMBER")}
                        </th>
                        <th
                          style={{ minWidth: "100px", padding: "8px" }}
                          rowSpan={2}
                        >
                          {t("PAN NUMBER")}
                        </th>
                        <th
                          style={{ minWidth: "100px", padding: "8px" }}
                          rowSpan={2}
                        >
                          {t("Account Number")}
                        </th>
                        <th
                          style={{ minWidth: "100px", padding: "8px" }}
                          rowSpan={2}
                        >
                          {t("Bank Name")}
                        </th>
                        <th
                          style={{ minWidth: "100px", padding: "8px" }}
                          rowSpan={2}
                        >
                          {t("IFSC CODE")}
                        </th>
                        <th
                          style={{ minWidth: "150px", padding: "8px" }}
                          rowSpan={2}
                        >
                          {t("Branch Name")}
                        </th>
                        {/* <th style={{ minWidth: "200px", padding: '8px' }}> Account Holder Name</th> */}
                        <th
                          style={{ minWidth: "200px", padding: "8px" }}
                          rowSpan={2}
                        >
                          {t("Passbook Doc")}
                        </th>
                        <th
                          style={{ minWidth: "200px", padding: "8px" }}
                          rowSpan={2}
                        >
                          {t("Cheque Doc")}
                        </th>
                        <th
                          style={{ minWidth: "200px", padding: "8px" }}
                          rowSpan={2}
                        >
                          {t("Pan Doc")}
                        </th>
                        <th
                          style={{ minWidth: "200px", padding: "8px" }}
                          rowSpan={2}
                        >
                          {t("Tan Doc")}
                        </th>
                        <th
                          style={{ minWidth: "200px", padding: "8px" }}
                          rowSpan={2}
                        >
                          {t("GST Doc")}
                        </th>
                        <th
                          style={{ minWidth: "200px", padding: "8px" }}
                          rowSpan={2}
                        >
                          {t("Aadhaar Doc")}
                        </th>
                        <th
                          style={{ minWidth: "200px", padding: "8px" }}
                          rowSpan={2}
                        >
                          {t("Action")}
                        </th>
                        <th style={headerStyle} colSpan={1}>
                          {t("Approved by")}
                        </th>
                      </tr>
                    </thead>
                    {currentBills?.length === 0 ? (
                      <tr>
                        <td
                          colSpan="20"
                          style={{
                            textAlign: "center",
                            padding: "20px",
                            backgroundColor: "#f9f9f9",
                          }}
                        >
                          {t("No data available")}
                        </td>
                      </tr>
                    ) : (
                      currentBills.map((vendor, index) => {
                        const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                        return (
                          <tbody>
                            <tr
                              key={index}
                              style={{
                                backgroundColor: bgColor,
                                fontSize: "18px",
                                fontWeight: "500",
                              }}
                            >
                              <td style={{ padding: "8px" }}>
                                {(currentPage - 1) * billsPerPage + index + 1}
                              </td>
                              <td style={{ padding: "8px" }}>
                                {vendor.UniqueID}
                              </td>
                              <td style={{ padding: "8px" }}>
                                {vendor.Bidder_CompanyName}
                              </td>
                              <td>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                  }}
                                >
                                  <img
                                    src={Email32}
                                    alt="email"
                                    style={{ width: "16px", height: "16px" }}
                                  />
                                  <span>{vendor.Email}</span>
                                </div>
                              </td>
                              <td style={{ padding: "8px" }}>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                  }}
                                >
                                  <img
                                    src={Location32}
                                    alt="address"
                                    style={{ width: "16px", height: "16px" }}
                                  />
                                  <span>{vendor.Address}</span>
                                </div>
                              </td>
                              <td style={{ padding: "8px" }}>{vendor.City}</td>
                              <td style={{ padding: "8px" }}>
                                {vendor.PinCode}
                              </td>
                              <td>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                  }}
                                >
                                  <img
                                    src={PhoneNumber32}
                                    alt="Phone Number"
                                    style={{ width: "16px", height: "16px" }}
                                  />
                                  <span>{vendor.Mobile_No}</span>
                                </div>
                              </td>
                              <td style={{ padding: "8px" }}>
                                {vendor.GST_No}
                              </td>
                              <td style={{ padding: "8px" }}>
                                {vendor.PAN_No}
                              </td>
                              <td style={{ padding: "8px" }}>
                                {vendor.Account_Number}
                              </td>
                              <td style={{ padding: "8px" }}>
                                {vendor.BANK_NAME}
                              </td>
                              <td style={{ padding: "8px" }}>
                                {vendor.IFSC_CODE}
                              </td>
                              <td style={{ padding: "8px" }}>
                                {vendor.BranchName}
                              </td>
                              {/* <td style={{ padding: '8px' }}>{vendor.Account_HolderName}</td> */}
                              <td style={{ padding: "8px" }}>
                                <a
                                  href={`${apiurl}/ContractorDocsImages/${vendor.PaasbookDoc}`}
                                  target="_blank"
                                >
                                  {vendor.PaasbookDoc}
                                </a>
                              </td>
                              <td style={{ padding: "8px" }}>
                                <a
                                  href={`${apiurl}/ContractorDocsImages/${vendor.ChequeDoc}`}
                                  target="_blank"
                                >
                                  {vendor.ChequeDoc}
                                </a>
                              </td>
                              <td style={{ padding: "8px" }}>
                                <a
                                  href={`${apiurl}/ContractorDocsImages/${vendor.PanDoc}`}
                                  target="_blank"
                                >
                                  {vendor.PanDoc}
                                </a>
                              </td>
                              <td style={{ padding: "8px" }}>
                                <a
                                  href={`${apiurl}/ContractorDocsImages/${vendor.TanDoc}`}
                                  target="_blank"
                                >
                                  {vendor.TanDoc}
                                </a>
                              </td>
                              <td style={{ padding: "8px" }}>
                                <a
                                  href={`${apiurl}/ContractorDocsImages/${vendor.GstDoc}`}
                                  target="_blank"
                                >
                                  {vendor.GstDoc}
                                </a>
                              </td>
                              <td style={{ padding: "8px" }}>
                                <a
                                  href={`${apiurl}/ContractorDocsImages/${vendor.AadharDoc}`}
                                  target="_blank"
                                >
                                  {vendor.AadharDoc}
                                </a>
                              </td>
                              <td style={{ padding: "8px" }}>
                                <button
                                  className="btn btn-sm btn-danger"
                                  onClick={(e) =>
                                    handleDeleteDeduction(vendor.UniqueID, e)
                                  }
                                >
                                  {t("Delete")}
                                </button>
                              </td>
                              <td
                                style={{
                                  padding: "8px",
                                  textAlign: "center",
                                }}
                              >
                                {vendor.Approvance1 === "true" ? (
                                  <div
                                    className="m-auto"
                                    style={{
                                      width: "20px",
                                      height: "20px",
                                      borderRadius: "6px",
                                      backgroundColor: "#16C60C",
                                      border: "none",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      fontSize: "18px",
                                      color: "white",
                                      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                    }}
                                  >
                                    ✓
                                  </div>
                                ) : vendor.Approvance1 === "false" ? (
                                  <div
                                    className="m-auto"
                                    style={{
                                      width: "20px",
                                      height: "20px",
                                      borderRadius: "6px",
                                      backgroundColor: "#dc2626",
                                      border: "none",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      fontSize: "18px",
                                      color: "white",
                                      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                    }}
                                  >
                                    ✕
                                  </div>
                                ) : (
                                  "-"
                                )}
                              </td>
                            </tr>
                          </tbody>
                        );
                      })
                    )}
                  </table>
                </div>

                <div className="col-12 mt-4">
                  <div className="row">
                    <div className="col-6">
                      <p className="text-gray-600" style={{ fontSize: "18px" }}>
                        {t("Showing ")}
                        {indexOfFirstBill + 1} {t("to")}{" "}
                        {Math.min(indexOfLastBill, filteredBills.length)}{" "}
                        {t("of")} {filteredBills.length} {t("entries")}
                      </p>
                    </div>

                    <div
                      className="col-6"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "end",
                      }}
                    >
                      <GooglePagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={setCurrentPage}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VendorList;
